<template>
  <div class="logo-txt">
    <h1 :class="['title', loaded ? 'on-load' : '']">
      <span ref="position" class="position">
        JUNIOR
      </span>
      <span ref="stack" class="stack">
        FULL-STACK
      </span>
      <span ref="dev" class="dev">
        WEB DEVELOPER
      </span>
    </h1>
  </div>
</template>

<script>
export default {
  name: "Logo-text",
  data() {
    return {
      loaded: true
    };
  },
  created() {
    setTimeout(() => {
      this.fadeIn();
    }, 1000);
  },
  mounted() {
    let position = this.$refs.position;
    let stack = this.$refs.stack;
    let dev = this.$refs.dev;
    let positionSplitted = position.textContent.split("");
    let stackSplitted = stack.textContent.split("");
    let devSplitted = dev.textContent.split("");
    position.textContent = "";
    stack.textContent = "";
    dev.textContent = "";

    positionSplitted.forEach(el => {
      position.innerHTML += '<span class="to-color">' + el + "</span>";
    });
    stackSplitted.forEach(el => {
      stack.innerHTML += '<span class="bouncing">' + el + "</span>";
    });
    devSplitted.forEach((el, i) => {
      let iForHumans = i + 1;
      if (iForHumans % 2) {
        dev.innerHTML += '<span class="rotate primary">' + el + "</span>";
      } else {
        dev.innerHTML += '<span class="rotate">' + el + "</span>";
      }
    });
  },
  methods: {
    fadeIn() {
      this.loaded = !this.loaded;
    }
  }
};
</script>

<style lang="scss">
.logo-txt {
  @include d-flex("center");
  .title {
    position: relative;
    z-index: 1;
    color: palette(1);
    font-family: $sans;
    filter: drop-shadow(2px 2px rgba(palette(1), 0.3));
    transform: translateY(125%);
    animation: onLoad 1s cubic-bezier(0.075, 0.82, 0.165, 1);
    transition: transform 350ms cubic-bezier(0.55, 0.085, 0.68, 0.53),
      opacity 300ms 150ms linear;
    &.on-load {
      transform: translateY(-250px);
      opacity: 0;
    }
    .position {
      position: absolute;
      bottom: -15.7px;
      font-size: 0.43rem;
      transform: rotate(-90deg) scale(1);
      left: -12px;
      .to-color {
        transition: color 500ms 500ms ease-out;
        &:hover {
          color: palette(4);
          transition: color 250ms linear;
        }
      }
    }
    .stack {
      position: absolute;
      top: 39px;
      font-family: "Josefin Slab", serif;
      font-size: 2.5rem;
      font-weight: normal;
      letter-spacing: 0.38rem;
      transform: translateX(10px);
      .bouncing {
        position: relative;
        display: inline-block;
        transition: transform 250ms 150ms cubic-bezier(0.49, 0.96, 0.44, 1.77),
          color 250ms 150ms ease;
        &:hover {
          color: palette(3);
          transform: scale(1.25, 1.25);
          transition: transform 150ms cubic-bezier(0.49, 0.96, 0.24, 1.97),
            color 150ms ease;
        }
      }
    }
    .dev {
      position: relative;
      top: 70px;
      font-size: 2rem;
      .rotate {
        &:nth-child(5) {
          margin-left: 10px;
        }
        position: relative;
        display: inline-block;
        transition: transform 250ms 150ms cubic-bezier(0.49, 0.96, 0.44, 1.77),
          color 250ms 150ms ease, opacity 250ms 150ms ease;
        &:hover {
          color: palette(3);
          opacity: 0.8;
          transform: matrix(0.8, 0.5, -0.5, 1, -5, 10);
          transition: transform 150ms cubic-bezier(0.49, 0.96, 0.24, 1.97),
            color 150ms ease;
        }
        &.primary {
          &:hover {
            color: palette(4);
          }
        }
      }
    }
  }
}

@media screen and (min-width: 768px) {
  .logo-txt {
    .title {
      transform: translateY(-100%) translateX(-40%);
      &.on-load {
        transform: translateY(-100%) translateX(50%);
        opacity: 0;
      }
      .position {
        bottom: 0;
        font-size: 0.6rem;
        left: -15px;
      }
      .stack {
        top: 21px;
        font-size: 3.6rem;
        letter-spacing: 0.25rem;
        transform: translateX(14px);
      }
      .dev {
        font-size: 2.6rem;
      }
    }
  }
}

@media screen and (min-width: 1100px) {
  .logo-txt {
    .title {
      transform: translateY(-65%) translateX(-40%);
      &.on-load {
        transform: translateY(-100%) translateX(50%);
        opacity: 0;
      }
      .position {
        bottom: 11.3px;
        font-size: 0.75rem;
        left: -19px;
      }
      .stack {
        top: 13px;
        font-size: 4.4rem;
        letter-spacing: 0.35rem;
      }
      .dev {
        font-size: 3.2rem;
      }
    }
  }
}
</style>
